import React, { useState } from 'react'
import { Col, Grid, Image, Row } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import injectStyles from 'react-jss'
import EditIcon from '@material-ui/icons/Edit'
import { Menu, MenuItem } from '@material-ui/core'
import moment from 'moment'
import { AmbassadorSection } from 'Components/City/Page/Ambassador/AmbassadorSection'
import * as CONST from '../../../../../../Reducers/Ambassador/const'
import StyledIconButton from '../../../../../../Components/Form/StyledIconButton'
import { authorization } from '../../../../../../Module/Auth/Auth'
import SubmitButton from 'Components/Form/SubmitButton'
import { formatPhoneNumber } from '../../../../../../Utils/Formatters'
import CountryWarnings from '../CountryWarnings'
import AmbassadorStatusChange from '../../StatusChange/AmbassadorStatusChange'
import { StatusBadge } from 'Components/StatusBadge'
import {
  getPayrollProviderData,
  shouldShowContractorType,
  shouldShowShowBaType,
} from '../../util'
import {
  BA_CATEGORY_TYPE_TO_LABEL,
  COUNTRY_CODE,
  PAYROLL_PROVIDER_TYPES,
} from '../../../../../../constants'
import { getContractorTypesLabelsByCountryCode } from '../../../../../../Utils/Misc'
import { getBADateOfBirth } from '../../../../../../Utils/User'
import { StarRating } from 'Components/StarRating'

const styles = {
  button: {
    marginTop: '10px',
  },
}

const businessNumberTitle = country => {
  switch (country) {
    case 'FR':
      return 'SIRET'
    case 'UK':
      return 'UTR'
    case 'AU':
      return 'ABN'
    default:
      return 'Business Number'
  }
}

const ContactDetailsSection = ({
  ambassador,
  onRefuse,
  city,
  handleUserActions,
  isBaUpdating,
  onFadeChange,
  isFadeLoading,
  fade,
  documents,
  nmbrsDocument,
  germanyContract,
  germanyPayroll,
  documentTypes,
  classes,
  missions,
  baView,
  setBaView,
}) => {
  // Contract, Payroll, Payment ID
  const isShowGermanyData = city && city.country.code == COUNTRY_CODE.GERMANY

  const showDateOfBirth = city && city.country.code !== COUNTRY_CODE.NETHERLANDS
  const history = useHistory()

  const countryCode = city.country.code
  const canShowContractorType = shouldShowContractorType(city.country.code)
  const canShowBaType = shouldShowShowBaType(city.country.code)

  const getActiveStatusText = ({ status, isVerified }) => {
    const button = (
      <div className={classes.button}>
        <SubmitButton
          hideSvg={true}
          value="Verify email"
          onClick={() => window.open(ambassador.emailVerificationLink)}
          id="verifyEmail"
        />
      </div>
    )
    const activeStatusText =
      status === CONST.AMBASSADOR_STATUS_KEY.ACTIVE && isVerified ? 'Yes' : 'No'
    return (
      <div>
        <span>
          {activeStatusText} {isVerified ? '' : '. Email is not verified'}
        </span>
        {!isVerified && button}
      </div>
    )
  }

  const formattedbusinessNumber =
    ambassador.businessNumber &&
    ambassador.businessNumber.replace(/.(?=.{4,}$)/g, '*')

  const status = ambassador && ambassador.status === 'waiting_for_review'
  const {
    label: nmbrsContractLabel,
    status: nmbrsContractStatus,
    payrollProviderName,
    showStatus,
  } = getPayrollProviderData({
    ambassador,
    userContract: nmbrsDocument.userContract,
  })
  const isNLCountry = ambassador.city.country.code === COUNTRY_CODE.NETHERLANDS
  const isNMBRSPayrollProvider = ambassador.id
    ? ambassador.payrollProvider === PAYROLL_PROVIDER_TYPES.NL_NMBRS
    : false

  const isCityManagerAssistant = authorization.isCityManagerAssistant()

  const [anchorEl, setAnchorEl] = useState(null)

  const handleMenuClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleEditClick = () => {
    history.push(history.location.pathname + '/edit')
    handleMenuClose()
  }

  const handleSetBaViewClick = () => {
    setBaView(!baView)
    handleMenuClose()
  }

  return (
    <AmbassadorSection>
      <Grid fluid>
        <Row>
          <Col style={{ position: 'absolute', right: 20, width: 50 }}>
            {(authorization.isAdmin() || authorization.isCityManager()) &&
            !isCityManagerAssistant ? (
              <StyledIconButton
                style={{ float: 'right' }}
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={handleMenuClick}
              >
                <EditIcon />
              </StyledIconButton>
            ) : isCityManagerAssistant ? (
              <StyledIconButton
                style={{ float: 'right' }}
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={() =>
                  history.push(history.location.pathname + '/edit')
                }
              >
                <EditIcon />
              </StyledIconButton>
            ) : null}
          </Col>
        </Row>
        <Row>
          <Col xs={2} className={'profile-picture-wrapper'}>
            <Image
              src={ambassador.profilePicture}
              className="profile-picture"
            />
            <div
              style={{ marginBottom: 20 }}
              className={'contact-details-user-name'}
            >{`${ambassador.firstName} ${ambassador.lastName}`}</div>
            <StarRating score={ambassador.rating} uniqueId="D30-letterbox" />
          </Col>
          <Col xs={9}>
            <Row>
              {ambassador.email && (
                <Col xs={4} className="ambassador-details-col">
                  <p className="col-title" cypress_id={'editBAPageEmailTitle'}>
                    Email Address
                  </p>
                  <p className="email">{ambassador.email}</p>
                </Col>
              )}
              {ambassador.mobilePhone && (
                <Col xs={4} className="ambassador-details-col">
                  <p
                    className="col-title"
                    cypress_id={'editBAPagePhoneNumberTitle'}
                  >
                    Phone number
                  </p>
                  <p className={'col-value'}>
                    {formatPhoneNumber(ambassador.mobilePhone) || '-'}
                  </p>
                </Col>
              )}
              {countryCode !== 'US' && (
                <Col xs={4} className="ambassador-details-col">
                  <p
                    className="col-title"
                    cypress_id={'editBAPageBusinessNumberTitle'}
                  >
                    {businessNumberTitle(countryCode)}
                  </p>
                  <p className={'col-value'}>
                    {formattedbusinessNumber || '-'}
                  </p>
                </Col>
              )}
              {ambassador.city && (
                <Col xs={4} className="ambassador-details-col">
                  <p className="col-title" cypress_id={'editBAPageCityTitle'}>
                    City
                  </p>
                  <p className={'col-value'}>{ambassador.city.name || '-'}</p>
                </Col>
              )}
              {ambassador.status && (
                <Col xs={4} className="ambassador-details-col">
                  <p className="col-title" cypress_id={'userStatus'}>
                    Status
                  </p>
                  <p className={'col-value'}>
                    {ambassador.isNoticePeriod
                      ? 'Notice period'
                      : CONST.AMBASSADOR_STATUS_LABEL[ambassador.status] || '-'}
                  </p>
                </Col>
              )}
              {ambassador.status && (
                <Col xs={4} className="ambassador-details-col">
                  <p className="col-title" cypress_id={'isVerifiedUserStatus'}>
                    Active
                  </p>
                  <p className={'col-value'}>
                    {getActiveStatusText(ambassador)}
                  </p>
                </Col>
              )}
              <Col xs={4} className="ambassador-details-col">
                <p className="col-title">Signup Date</p>
                <p className="text-capitalize">
                  {moment(parseInt(ambassador.memberSince, 10)).format(
                    'D MMM YYYY',
                  )}
                </p>
              </Col>
              {isNLCountry && (
                <Col xs={4} className="ambassador-details-col">
                  <p className="col-title">Payment Provider</p>
                  <span>
                    <p className={'row-value'}>{payrollProviderName}</p>
                    <span className={'row-spacing'} />
                    {isNMBRSPayrollProvider && showStatus && (
                      <StatusBadge variant={nmbrsContractStatus}>
                        {nmbrsContractLabel}
                      </StatusBadge>
                    )}
                  </span>
                </Col>
              )}

              {isShowGermanyData && (
                <Col xs={4} className="ambassador-details-col">
                  <p className="col-title">Middle name</p>
                  <span className="col-value">
                    {germanyPayroll && germanyPayroll.middleName
                      ? germanyPayroll.middleName
                      : '-'}
                  </span>
                </Col>
              )}
              {!isCityManagerAssistant ? (
                <Col xs={4} className="ambassador-details-col">
                  <p className="col-title">Bank Address 1</p>
                  <p className="text-capitalize">
                    {ambassador.paymentDetails &&
                    ambassador.paymentDetails.bankAddress1
                      ? ambassador.paymentDetails.bankAddress1
                      : '-'}
                  </p>
                </Col>
              ) : null}
              {!isCityManagerAssistant ? (
                <Col xs={4} className="ambassador-details-col">
                  <p className="col-title">Bank Address 2</p>
                  <p className="text-capitalize">
                    {ambassador.paymentDetails &&
                    ambassador.paymentDetails.bankAddress2
                      ? ambassador.paymentDetails.bankAddress2
                      : '-'}
                  </p>
                </Col>
              ) : null}
              {!isCityManagerAssistant ? (
                <Col xs={4} className="ambassador-details-col">
                  <p className="col-title">Bank Post Code</p>
                  <p className="text-capitalize">
                    {ambassador.paymentDetails &&
                    ambassador.paymentDetails.bankPostCode
                      ? ambassador.paymentDetails.bankPostCode
                      : '-'}
                  </p>
                </Col>
              ) : null}
              {canShowContractorType ? (
                <Col xs={4} className="ambassador-details-col">
                  <p className="col-title">Contractor type</p>
                  <p className="text-capitalize">
                    {
                      getContractorTypesLabelsByCountryCode(countryCode)[
                        ambassador.contractorType
                      ]
                    }
                  </p>
                </Col>
              ) : null}
              {canShowBaType ? (
                <Col xs={4} className="ambassador-details-col">
                  <p className="col-title">BA Type</p>
                  <p className="text-capitalize">
                    {BA_CATEGORY_TYPE_TO_LABEL[ambassador.category] || '-'}
                  </p>
                </Col>
              ) : null}
              {showDateOfBirth && (
                <Col xs={4} className="ambassador-details-col">
                  <p className="col-title">Date of Birth</p>
                  <p className="text-capitalize">
                    {ambassador.dateOfBirth
                      ? getBADateOfBirth(ambassador).format('D MMM YYYY')
                      : '-'}
                  </p>
                </Col>
              )}
              {isShowGermanyData && (
                <React.Fragment>
                  <Col xs={4} className="ambassador-details-col">
                    <p className="col-title">Address</p>
                    <span className="col-value">
                      {germanyContract && germanyContract.address
                        ? germanyContract.address
                        : '-'}
                    </span>
                  </Col>
                  <Col xs={4} className="ambassador-details-col">
                    <p className="col-title">No.</p>
                    <span className="col-value">
                      {germanyContract && germanyContract.houseNumber
                        ? germanyContract.houseNumber
                        : '-'}
                    </span>
                  </Col>
                  <Col xs={4} className="ambassador-details-col">
                    <p className="col-title">Apartment, suite etc.</p>
                    <span className="col-value">
                      {germanyContract && germanyContract.exactAddress
                        ? germanyContract.exactAddress
                        : '-'}
                    </span>
                  </Col>
                  <Col xs={4} className="ambassador-details-col">
                    <p className="col-title">City of Residence</p>
                    <span className="col-value">
                      {germanyContract && germanyContract.city
                        ? germanyContract.city
                        : '-'}
                    </span>
                  </Col>
                  <Col xs={4} className="ambassador-details-col">
                    <p className="col-title">Postcode (PLZ)</p>
                    <span className="col-value">
                      {germanyContract && germanyContract.postalCode
                        ? germanyContract.postalCode
                        : '-'}
                    </span>
                  </Col>
                  <Col xs={4} className="ambassador-details-col">
                    <p className="col-title">Payment ID</p>
                    <span className="col-value">
                      {ambassador.germanyPaymentId}
                    </span>
                  </Col>
                </React.Fragment>
              )}
            </Row>
          </Col>
        </Row>
      </Grid>

      <CountryWarnings country={countryCode} status={status} />

      <AmbassadorStatusChange
        ambassador={ambassador}
        timezone={city.timezone}
        onRefuse={onRefuse}
        countryCode={countryCode}
        onChange={handleUserActions}
        onFadeChange={onFadeChange}
        fade={fade}
        disabled={!!ambassador.isLoading || isFadeLoading || isBaUpdating}
        documents={documents}
        nmbrsDocument={nmbrsDocument}
        documentTypes={documentTypes}
        germanyContract={germanyContract}
        germanyPayroll={germanyPayroll}
        missions={missions}
      />

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={handleEditClick}>Edit</MenuItem>
        <MenuItem onClick={handleSetBaViewClick}>
          {baView ? 'Disable Ba View' : 'Enable Ba View'}
        </MenuItem>
      </Menu>
    </AmbassadorSection>
  )
}

export default injectStyles(styles)(ContactDetailsSection)
